import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import FundMatchTab from "./dashboard/FundMatchTab";
import FundReachTab from "./dashboard/FundReachTab";
import AdminHubTab from "./dashboard/AdminHubTab";
import ImpactGrowTab from "./dashboard/ImpactGrowTab";
import ResourceHubTab from "./dashboard/ResourceHubTab";
import DataIntelTab from "./dashboard/DataIntelTab";
import SettingsTab from "./dashboard/SettingsTab";
import PositioningTab from "./dashboard/PositioningTab";
import { useAuth } from "../contexts/AuthContext";

export const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("fundmatch");
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // BN from auth user (set at registration/login) or localStorage fallback
  const charityBN = user?.charity_bn || localStorage.getItem('impactplexus_charity_bn') || null;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "fundmatch":
        return <FundMatchTab charityBN={charityBN} onNavigate={setActiveTab} />;
      case "fundreach":
        return <FundReachTab charityBN={charityBN} onNavigate={setActiveTab} storageKey="impactplexus_pursuits_v1" />;
      case "adminhub":
        return <AdminHubTab />;
      case "impactgrow":
        return <ImpactGrowTab />;
      case "resourcehub":
        return <ResourceHubTab />;
      case "dataintel":
        return <DataIntelTab />;
      case "settings":
        return <SettingsTab />;
      case "positioning":
        return <PositioningTab />;
      default:
        return <FundMatchTab charityBN={charityBN} />;
    }
  };

  return (
    <DashboardLayout activeTab={activeTab} onTabChange={setActiveTab} user={user} onLogout={handleLogout}>
      {renderTabContent()}
    </DashboardLayout>
  );
};

export default Dashboard;
